import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';

export function Breadcrumbs({ items }) {
  return (
    <nav aria-label="Breadcrumb" className="mb-6">
      <ol className="flex items-center gap-2 text-sm text-[var(--text-muted)]">
        <li>
          <Link to="/" className="flex items-center gap-1 hover:text-[var(--text)] transition-colors">
            <Home size={14} />
            <span>Home</span>
          </Link>
        </li>
        {items.map((item, index) => (
          <React.Fragment key={index}>
            <ChevronRight size={14} className="text-[var(--border-custom)]" />
            <li>
              {item.url ? (
                <Link to={item.url} className="hover:text-[var(--text)] transition-colors">
                  {item.name}
                </Link>
              ) : (
                <span className="text-[var(--text)]">{item.name}</span>
              )}
            </li>
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
}
